import { X } from "lucide-react";
import { useEffect, useState } from "react";

export default function Gallery({ images, title }: { images: string[]; title: string }) {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") setActive(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <div className="gallery">
        {images.map((image, index) => (
          <button key={image} className="gallery-item" type="button" onClick={() => setActive(image)}>
            <img src={image} alt={`${title} screenshot ${index + 1}`} loading="lazy" />
          </button>
        ))}
      </div>
      {active && (
        <div className="lightbox" role="dialog" aria-modal="true" aria-label={`${title} screenshot`}>
          <button className="icon-button lightbox-close" type="button" onClick={() => setActive(null)} aria-label="Close screenshot">
            <X aria-hidden="true" />
          </button>
          <img src={active} alt={`${title} enlarged screenshot`} />
        </div>
      )}
    </>
  );
}
